
export function localeCompareDK(a: string, b: string, sortNumbers = false): number {
  return a.localeCompare(b, 'da', { sensitivity: 'base', numeric: sortNumbers });
}
